// extracted by mini-css-extract-plugin
export default {"title":"title_title__QEfkM","animatedBar":"title_animatedBar__bdJR1","barAnimation":"title_barAnimation__mXsFA"};